import { Theme } from '@mui/material';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';

export const useUploadActionStyles = makeStyles<void, 'hoverAction'>()(
  (theme: Theme, _params, classes) => ({
    root: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

      [`&:hover > .${classes.hoverAction}`]: {
        opacity: 1,
      },
    },

    hoverAction: {
      opacity: 0,
    },
    centeredElement: {
      position: 'absolute',
      zIndex: theme.zIndex.tooltip - 1,
    },

    fileInput: {
      cursor: 'pointer',
      '&::file-selector-button': {
        cursor: 'pointer',
      },
      position: 'absolute',
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
      opacity: 0,
      width: '100%',
      height: '100%',
      zIndex: theme.zIndex.tooltip,
    },
  }),
);

type UploadActionProps = {
  proccessFiles: (files: FileList) => void;
  disabled?: boolean;
  children: React.ReactNode;
  accept?: string;
};

const UploadAction = ({
  children,
  disabled,
  proccessFiles,
  accept = 'image/*',
}: UploadActionProps) => {
  const { classes } = useUploadActionStyles();

  const handleFileChange = (files: FileList | null) => {
    if (files) {
      proccessFiles(files);
    }
  };

  return (
    <div className={classes.root}>
      {children}
      {disabled !== true && (
        <input
          accept={accept}
          type="file"
          className={classes.fileInput}
          onChange={(event) => handleFileChange(event.target.files)}
        />
      )}
    </div>
  );
};

export default UploadAction;
